// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_uy-8";
export var editMode = "_uy-3";
export var headerRow = "_uy-a";
export var headerTitle = "_uy-b";
export var product = "_uy-1";
export var productDetails = "_uy-5";
export var productDivider = "_uy-7";
export var productImage = "_uy-2";
export var productInfo = "_uy-4";
export var productTitle = "_uy-6";
export var strikethrough = "_uy-9";
export var upsellProductsCard = "_uy-0";